import actions from './actions';

const initialState = {
  isSearching: false,
  isCreating: false,
  isUpdating: false,
};

export default function permissionReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SEARCH_SUBSCRIPTION_ACTIVITIES:
    case actions.SEARCH_SUBSCRIPTION_PROGRAM_CONTRACTS:
    case actions.SEARCH_SUBSCRIPTION_PROGRAM_CONTRACT_ORDERS:
    case actions.SEARCH_MEMBER_PRIVILEGE_USAGE_TRANSACTION_RECORDS:
    case actions.GET_SUBSCRIPTION_RECEIPT_CONFIGURATION:
    case actions.GET_SUBSCRIPTION_HANDLING_FEE_CONFIGURATION:
    case actions.GET_SUBSCRIPTION_RENEWAL_CONFIGURATION:
    case actions.SEARCH_SUBSCRIPTION_RENEWAL_NOTIFICATION_CONFIGURATIONS:
    case actions.SEARCH_SUBSCRIPTION_PROGRAM_MEMBER_PRIVILEGE:
    case actions.FIND_SUBSCRIPTION_PROGRAM_MEMBER_PRIVILEGE:
      return {
        ...state,
        isSearching: true,
      };
    case actions.SEARCH_SUBSCRIPTION_PROGRAM_CONTRACTS_END:
    case actions.SEARCH_SUBSCRIPTION_PROGRAM_CONTRACT_ORDERS_END:
    case actions.SEARCH_MEMBER_PRIVILEGE_USAGE_TRANSACTION_RECORDS_END:
    case actions.GET_SUBSCRIPTION_RECEIPT_CONFIGURATION_ENDED:
    case actions.GET_SUBSCRIPTION_HANDLING_FEE_CONFIGURATION_ENDED:
    case actions.GET_SUBSCRIPTION_RENEWAL_CONFIGURATION_ENDED:
    case actions.SEARCH_SUBSCRIPTION_RENEWAL_NOTIFICATION_CONFIGURATIONS_ENDED:
    case actions.SEARCH_SUBSCRIPTION_PROGRAM_MEMBER_PRIVILEGE_END:
    case actions.FIND_SUBSCRIPTION_PROGRAM_MEMBER_PRIVILEGE_END:
      return {
        ...state,
        isSearching: false,
      };
    case actions.UPDATE_SUBSCRIPTION_RECEIPT_CONFIGURATION:
    case actions.UPDATE_SUBSCRIPTION_HANDLING_FEE_CONFIGURATION:
    case actions.UPDATE_SUBSCRIPTION_RENEWAL_CONFIGURATION:
      return {
        ...state,
        isUpdating: true,
      };
    case actions.UPDATE_SUBSCRIPTION_RECEIPT_CONFIGURATION_ENDED:
    case actions.UPDATE_SUBSCRIPTION_HANDLING_FEE_CONFIGURATION_ENDED:
    case actions.UPDATE_SUBSCRIPTION_RENEWAL_CONFIGURATION_ENDED:
      return {
        ...state,
        isUpdating: false,
      };
    default:
      return state;
  }
}
